import { render, staticRenderFns } from "./rechargeRemedy.vue?vue&type=template&id=4c529b5e&scoped=true&"
import script from "./rechargeRemedy.vue?vue&type=script&lang=js&"
export * from "./rechargeRemedy.vue?vue&type=script&lang=js&"
import style0 from "./rechargeRemedy.vue?vue&type=style&index=0&id=4c529b5e&lang=less&scoped=true&"
import style1 from "./rechargeRemedy.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c529b5e",
  null
  
)

export default component.exports